import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const yesPoints = ['Tu negocio o idea necesita una página YA', 'Estás harto de diseñadores que cobran una fortuna', 'No sabes código (y no quieres aprenderlo)', 'Quieres algo que se vea caro y profesional', 'Eres coach, emprendedor o freelancer'];
const noPoints = ['Crees que hacer una página debe tomar meses', 'Prefieres postergar 6 meses más', 'No tienes 90 minutos para invertir', 'Ya tienes una página que funciona perfectamente'];
export function ForWho() {
  return <section className="py-20 px-4 bg-white" data-id="element-35">
      <div className="max-w-6xl mx-auto" data-id="element-36">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-37">
          <h2 className="font-playfair text-4xl md:text-6xl font-bold text-gray-900 mb-16 text-center" data-id="element-38">
            ¿Este Workshop es Para Ti?
          </h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-39">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="bg-green-50 border-2 border-green-200 p-8 rounded-xl" data-id="element-40">
              <div className="flex items-center gap-3 mb-6" data-id="element-41">
                <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center" data-id="element-42">
                  <CheckIcon className="w-6 h-6 text-white" data-id="element-43" />
                </div>
                <h3 className="font-playfair text-3xl font-bold text-gray-900" data-id="element-44">
                  SÍ es para ti si:
                </h3>
              </div>
              <ul className="space-y-4" data-id="element-45">
                {yesPoints.map((point, index) => <li key={index} className="flex items-start gap-3" data-id="element-46">
                    <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" data-id="element-47" />
                    <span className="text-gray-800 text-lg" data-id="element-48">{point}</span>
                  </li>)}
              </ul>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="bg-red-50 border-2 border-red-200 p-8 rounded-xl" data-id="element-49">
              <div className="flex items-center gap-3 mb-6" data-id="element-50">
                <div className="w-10 h-10 bg-red-500 rounded-full flex items-center justify-center" data-id="element-51">
                  <XIcon className="w-6 h-6 text-white" data-id="element-52" />
                </div>
                <h3 className="font-playfair text-3xl font-bold text-gray-900" data-id="element-53">
                  NO es para ti si:
                </h3>
              </div>
              <ul className="space-y-4" data-id="element-54">
                {noPoints.map((point, index) => <li key={index} className="flex items-start gap-3" data-id="element-55">
                    <XIcon className="w-5 h-5 text-red-600 flex-shrink-0 mt-1" data-id="element-56" />
                    <span className="text-gray-800 text-lg" data-id="element-57">{point}</span>
                  </li>)}
              </ul>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}